import {
  FOC_TOUR_LABEL_AI_FOC,
  FOC_TOUR_LABEL_AI_IOC,
} from '../focTourLabels';
import {
  FOC_AI_FOC_TOUR_HREF,
  FOC_AI_FOC_TOUR_PARAM,
  FOC_AI_FOC_TOUR_STEPS,
} from './focAiFocTourSteps';
import {
  FOC_AI_IOC_TOUR_HREF,
  FOC_AI_IOC_TOUR_PARAM,
  FOC_AI_IOC_TOUR_STEPS,
} from './focAiIocTourSteps';
import type { FocAiTourStepDef } from './focAiTourTypes';

export {
  FOC_AI_IOC_TOUR_HREF,
  FOC_AI_FOC_TOUR_HREF,
};

export type FocAiTourKey = 'ioc' | 'foc';

export type FocAiTourEntry = {
  key: FocAiTourKey;
  param: string;
  label: string;
  href: string;
  covers: readonly string[];
  steps: readonly FocAiTourStepDef[];
};

export const FOC_AI_TOUR_ENTRIES: readonly FocAiTourEntry[] = [
  {
    key: 'ioc',
    param: FOC_AI_IOC_TOUR_PARAM,
    label: FOC_TOUR_LABEL_AI_IOC,
    href: FOC_AI_IOC_TOUR_HREF,
    covers: ['23.1'],
    steps: FOC_AI_IOC_TOUR_STEPS,
  },
  {
    key: 'foc',
    param: FOC_AI_FOC_TOUR_PARAM,
    label: FOC_TOUR_LABEL_AI_FOC,
    href: FOC_AI_FOC_TOUR_HREF,
    covers: ['23.2'],
    steps: FOC_AI_FOC_TOUR_STEPS,
  },
];

export function findFocAiTourEntryByParam(
  searchParams: URLSearchParams
): FocAiTourEntry | null {
  for (const entry of FOC_AI_TOUR_ENTRIES) {
    if (searchParams.get(entry.param) === '1') return entry;
  }
  return null;
}
